import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { PopupEntryPoint } from '../shared/popup-entry-point';
import { entryPoint, type EntryPointParams } from './collectionChangePlanPopup.entrypoint';
import { DIALOG_CONFIG } from './dialog-config';

export const CollectionChangePlanPopup = (): React.JSX.Element => {
	const { collectionEntitlementId } = useEditionAwareness();

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`,
		}),
		[collectionEntitlementId],
	);

	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			placement={'bottom-end'}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
};
